interface MetaTagsOptions {
  title?: string;
  description?: string;
  imageUrl?: string;
  type?: string;
}

/**
 * Sets meta tags for SEO and social sharing
 */
export function setMetaTags(options?: MetaTagsOptions): void {
  // Safely access options with null checks
  const safeOptions = options || {};
  const title = safeOptions.title || '';
  const description = safeOptions.description || '';
  const imageUrl = safeOptions.imageUrl || '';
  const type = safeOptions.type || 'website';

  // Set title
  if (title) {
    document.title = `${title} | Bitcoin Puzzles`;
  }

  // Helper function to create or update meta tags
  const setMetaTag = (name: string, content: string) => {
    let meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = name;
      document.head.appendChild(meta);
    }
    meta.content = content;
  };

  // Helper function to create or update Open Graph and Twitter meta tags
  const setPropertyMetaTag = (property: string, content: string) => {
    let meta = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('property', property);
      document.head.appendChild(meta);
    }
    meta.content = content;
  };

  // Set description meta tag
  if (description) {
    const safeDescription = description.length > 160 ? description.substring(0, 160) : description;
    setMetaTag('description', safeDescription);
  }

  // Set Open Graph meta tags
  if (title) {
    setPropertyMetaTag('og:title', `${title} | Bitcoin Puzzles`);
  }
  
  if (description) {
    const safeDescription = description.length > 160 ? description.substring(0, 160) : description;
    setPropertyMetaTag('og:description', safeDescription);
  }
  
  setPropertyMetaTag('og:type', type);
  
  if (imageUrl) {
    setPropertyMetaTag('og:image', imageUrl);
  }

  // Set Twitter meta tags
  if (title) {
    setPropertyMetaTag('twitter:title', `${title} | Bitcoin Puzzles`);
  }
  
  if (description) {
    const safeDescription = description.length > 160 ? description.substring(0, 160) : description;
    setPropertyMetaTag('twitter:description', safeDescription);
  }
  
  if (imageUrl) {
    setPropertyMetaTag('twitter:image', imageUrl);
    setMetaTag('twitter:card', 'summary_large_image');
  }
}
